import { render, staticRenderFns } from "./CatsafeLogoSvg.vue?vue&type=template&id=8fa033a4&"
import script from "./CatsafeLogoSvg.vue?vue&type=script&lang=js&"
export * from "./CatsafeLogoSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports